import TabOptions from '../options';

export class Model {}
export class Tab {
  id = 'Ten';
  title = 'X';
  model = new Model();
  valid = true;
  options = new TabOptions(new Model());
  build = (model) => {
    const options = model.categories
      .flatMap((c) => c.areas)
      .flatMap((a) => a.types)
      .flatMap((t) => t.options);
    return {
      tab: this.id,
      options,
    };
  };
}
export default new Tab();
